var _g, _line, _g2, _g3, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_8",
    "data-name": "Grupo 8",
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 17,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 16,
    rx: 2.5,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    "data-name": "L\\xEDnea 21",
    y2: 11,
    transform: "translate(7.5 3)",
    fill: "none",
    strokeWidth: 2,
    strokeDasharray: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    transform: "translate(17 4)",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    transform: "translate(22 9)",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_22",
    "data-name": "L\\xEDnea 22",
    x1: 5,
    y2: 9,
    transform: "translate(19 4)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.ff005c7d13580a1e80ee129a53423045.svg";
export { ForwardRef as ReactComponent };